import { RawCollection } from '../types';

interface RemoveFromCollectionCacheProps {
    itemId: string;

    /**
     * collectionId is optional, but it's a slight optimization if we know it.
     */
    collectionId?: string;
}

export const removeItemFromCollectionCache = (
    oldData: RawCollection[],
    { itemId, collectionId }: RemoveFromCollectionCacheProps
): {
    newData?: RawCollection[];
    removedItem?: RawCollection['items'][number];
    removedItemIndex?: number;
    removedFromCollectionId?: string;
} => {
    let removedItem;
    let removedItemIndex;
    let removedFromCollectionId;

    const newData = oldData.map((collection) => {
        if (collectionId && collection.id !== collectionId) {
            return collection;
        }

        return {
            ...collection,
            items: collection.items.filter((item, i) => {
                if (item.id === itemId) {
                    removedItem = item;
                    removedItemIndex = i;
                    removedFromCollectionId = collection.id;
                    return false;
                }

                return true;
            }),
        };
    });

    return { newData, removedItem, removedItemIndex, removedFromCollectionId };
};
